import { AnyAction, combineReducers } from 'redux'

import { ActionTypes } from '../actions'
import ui, { ConfigProviderState, initialUiState } from './ui'
import waypoints, { initialWaypointsState, WaypointsState } from './waypoints'
import { Params as ParamsState } from 'embed/services/QueryParams'

import application, { ApplicationState, initialApplicationState } from 'embed/reducers/application'
import auth, { AuthState, initialAuthState } from 'embed/reducers/auth'
import config, { initialConfigState } from 'embed/reducers/config'
import filters, { FiltersState, initialFiltersState } from 'embed/reducers/filters'
import loading, { initialLoadingState, LoadingState } from 'embed/reducers/loading'
import params, { initialParamsState } from 'embed/reducers/params'
import parent, { initialParentState } from 'embed/reducers/parent'
import rates, { initialRatesState, RatesState } from 'embed/reducers/rates'
import { reducer as experimentReducer, ExperimentState, initialExperimentState } from 'embed/experiment/slice'
import { Config } from '@evenfinancial/even-ts-static'

import { DeepReadonly } from 'utility-types'

export type CommonState = DeepReadonly<{
  application: ApplicationState
  auth: AuthState
  config: Config
  experiment: ExperimentState
  filters: FiltersState
  loading: LoadingState
  params: ParamsState
  parent: object
  rates: RatesState
}>

interface MultiProdState extends CommonState {
  ui: ConfigProviderState
  waypoints: WaypointsState
}

export type MultiProductState = DeepReadonly<MultiProdState>

export const initialCommonState: CommonState = {
  application: initialApplicationState,
  auth: initialAuthState,
  config: initialConfigState,
  experiment: initialExperimentState,
  filters: initialFiltersState,
  loading: initialLoadingState,
  params: initialParamsState,
  parent: initialParentState,
  rates: initialRatesState,
}

export const initialMultiProductState: MultiProductState = {
  ...initialCommonState,
  ui: initialUiState,
  waypoints: initialWaypointsState,
}

const commonReducers = {
  application,
  auth,
  config,
  experiment: experimentReducer,
  filters,
  loading,
  params,
  parent,
  rates,
}

const combineReducersWrapper = (globalState: MultiProductState, globalAction: AnyAction) => {
  // Provide the query params to reducers that need access to them.
  const reducers = {
    ...commonReducers,
    ui: (state: ConfigProviderState, action: ActionTypes) => ui(state, action),
    waypoints,
  }

  return combineReducers<MultiProductState>(reducers)(globalState, globalAction)
}

export default combineReducersWrapper
